<template>
<div class="chapter">
<div class="inner_page">
<p class="fma"><b>Acknowledgments</b></p>
<p class="ackp">To my friend, Mary Abreu, the Craft Addict. “Thank you” seems inadequate. Your guidance, advice, and friendship have meant more to me than I can ever express. I couldn’t have done this without you.</p>
<p class="ackp">To Roxane Cerda for believing in my idea and helping make this possible.</p>
<p class="ackp">To Karla Menaugh, Sadhana Wray, and everyone at C&amp;T who helped me create a book I’ve wanted to write for ten years.</p>
<p class="ackp">Thank you, Andover Fabrics, Dear Stella Design, Michael Miller Fabrics, and Westminster Fibers, for all the fabric you supplied.</p>
<p class="ackp">Thank you to Aurifil for sending me your amazing thread.</p>
<p class="ackp">A big thank-you to Sarah Phillips at Intown Quilters for letting me teach at your shop and for all your support. I’m lucky that you took a chance on me so long ago.</p>
<p class="ackp">To the cheerleaders, old and new, that I always have surrounding me: Hope Goldberg, Merry Bentley-Barlow, Hannah Burke, Ingie Derouin, Elizabeth Durel, Amy Higgins, Jacqueline Johnson, Callie Kaiser, Marnie Katz, Kendra Sanderson, Lauren Surden, and Ro Lawson. Your words of encouragement never fell on deaf ears. I love each of you dearly.</p>
<p class="ackp">To Taffy McLaughlin for being such a great mentor over the years.</p>
<p class="ackp">To my mother-in-law, Claire, for all your support and encouragement.</p>
<p class="ackp">To my dad, Mike, for always encouraging me to follow my dreams, and to my sister, Laura, for never wanting to learn how to sew.</p>
<p class="ackp">Most of all, to my husband, Mike, and our boys, Sean and Quinn, for tolerating all the missed meals, dirty laundry, and late nights while I wrote this book. I love you!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Ack.vue?68efa134